import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 3, 2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  title: {
    marginBottom: theme.spacing(0.5),
    color: '#172024',
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  list: {
    borderTop: '1px solid #E0E0E0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    cursor: 'pointer',
    borderBottom: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.02)',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
    '&$rowPast': {
      '& $startTime': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $endTime': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $name': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $description': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $durationText': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $durationIcon': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $chevron': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      gap: theme.spacing(1.5),
    },
  },
  rowPast: {},
  rowStatic: {
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& $chevron': {
      display: 'none',
    },
    '& $chevronMobile': {
      display: 'none',
    },
  },
  timeColumn: {
    flex: '0 0 88px',
    minWidth: 88,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  compactTime: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    columnGap: theme.spacing(1),
  },
  contentCluster: {
    display: 'flex',
    flex: '1 1 auto',
    minWidth: 0,
    gap: theme.spacing(2),
    alignItems: 'stretch',
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      gap: theme.spacing(1.5),
      paddingRight: theme.spacing(4),
    },
  },
  dateLabel: {
    fontSize: '0.75rem',
    lineHeight: 1.3,
    fontWeight: 600,
    color: '#172024',
    marginBottom: 2,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
  },
  compactTimeRange: {
    fontWeight: 700,
    fontSize: '0.8125rem',
    lineHeight: 1.25,
    color: '#172024',
    whiteSpace: 'nowrap',
  },
  startTime: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  endTime: {
    fontSize: '0.8125rem',
    lineHeight: 1.3,
    color: theme.palette.text.secondary,
    marginTop: 2,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  accentBar: {
    flex: '0 0 4px',
    alignSelf: 'stretch',
    borderRadius: 4,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      minHeight: 0,
    },
  },
  detailsColumn: {
    flex: '1 1 auto',
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      flex: '1 1 0',
      minWidth: 0,
    },
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
      marginBottom: 0,
    },
  },
  titleBlock: {
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      display: 'contents',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
      width: '100%',
      marginBottom: 0,
    },
  },
  titleLine: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      width: '100%',
    },
  },
  name: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#172024',
    margin: 0,
    minWidth: 0,
    flex: '1 1 auto',
  },
  upNextBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 4,
    color: '#FFFFFF',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.4,
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  categoryBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 10px',
    borderRadius: 999,
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  description: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    margin: 0,
  },
  trailingColumn: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexShrink: 0,
    marginLeft: 'auto',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  duration: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  durationIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
  },
  durationText: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  chevron: {
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.38)',
  },
  chevronMobile: {
    position: 'absolute',
    top: '50%',
    right: theme.spacing(1.5),
    transform: 'translateY(-50%)',
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.38)',
    pointerEvents: 'none',
  },
  footer: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 3),
    borderTop: '1px solid #E0E0E0',
  },
  footerButton: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.5),
      '& .MuiSvgIcon-root': {
        fontSize: 18,
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  emptyList: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '18px',
    borderTop: '1px solid #E0E0E0',
  },
}))

export default useStyles
